import { IError, ILoading, useDidMount } from "xa-generics";
import { DetailedCourierTurnModel } from "../../../Models/DetailedCourierTurn.model";
import { DetailedCourierModel } from "../../../Models/DetailedCourier.model";
import { ITurnResponse } from "../Interface/ITurnResponse.interface";
import { ProductModel } from "../Model/Product.model";
import { useState } from "react";
import { RoundDAO } from "../../../Api/DAO/CourierTurn.dao";
import { useMatch } from "react-router";
import LabelPrintingView from "../View/LabelPrinting.view";

export type ILabelPrintingProps = {};

const LabelPrinting: React.FC<ILabelPrintingProps> = (props) => {
    const path = useMatch("/print/labels/:round_id");

    const [error, setError] = useState<IError>(null);
    const [loading, setLoading] = useState<ILoading>(true);
    const [products, setProducts] = useState<ProductModel[]>([]);
    const [turn, setTurn] = useState<DetailedCourierTurnModel | null>(null);
    const [courier, setCourier] = useState<DetailedCourierModel | null>(null);

    const loadRound = (): void => {
        setLoading(
            RoundDAO.loadTurn(path!.params.round_id!)
                .then((data: ITurnResponse) => {
                    setProducts(data.products);
                    setCourier(data.courier);
                    setTurn(data.turn);
                })
                .catch((error: IError) => setError(error))
                .finally(() => setLoading(false))
        );
    };

    useDidMount(loadRound);

    return (
        <LabelPrintingView
            products={products}
            loading={loading}
            courier={courier}
            error={error}
            turn={turn}
        />
    );
};

export default LabelPrinting;
